// Catálogo único dos tipos de campo do Form Builder — compartilhado entre
// FieldPalette (lista de tipos para adicionar), FieldCanvas (rótulo do badge
// de tipo) e FieldProperties (select "Tipo de campo"), para não duplicar
// rótulos/ícones em três lugares e correr o risco de ficarem inconsistentes.
//
// Ícones restritos aos já usados em outros pontos do app (vue-feather-icons
// tem um conjunto fixo — um nome não confirmado renderiza em branco).
export const FIELD_TYPE_CATALOG = [
  { value: 'text', label: 'Texto', icon: 'EditIcon' },
  { value: 'textarea', label: 'Texto longo', icon: 'AlignLeftIcon' },
  { value: 'number', label: 'Número', icon: 'ListIcon' },
  { value: 'date', label: 'Data', icon: 'CalendarIcon' },
  { value: 'boolean', label: 'Sim/Não', icon: 'CheckCircleIcon' },
  { value: 'single_choice', label: 'Seleção única', icon: 'CircleIcon' },
  { value: 'multiple_choice', label: 'Seleção múltipla', icon: 'CheckSquareIcon' },
  { value: 'photo', label: 'Foto', icon: 'CameraIcon' },
  { value: 'file', label: 'Arquivo', icon: 'PaperclipIcon' },
  { value: 'image_annotation', label: 'Marcação em imagem', icon: 'MapPinIcon' },
  { value: 'section_break', label: 'Quebra de seção', icon: 'LayersIcon' },
]

export function fieldTypeLabel(type) {
  const found = FIELD_TYPE_CATALOG.find(t => t.value === type)
  return found ? found.label : type
}

export default FIELD_TYPE_CATALOG
